import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { isEmpty } from 'lodash'

import { MODAL } from '../../../reduxs'
import PropTypes from 'prop-types'
import { StyleModal } from './style'
import DeleteStepsModal from '../../DeleteStepsModal'
import { checkPermission } from '../../../helpers'
import {
  REPEAT_OPTION_STATUS,
  REPEAT_BOOKING,
  BOOKING_DETAIL_VIEW,
  ROUTE,
} from '../../../helpers/constants'

import BookingViewModal from './BookingViewModal'
import MoreViewModal from './MoreViewModal'
import YearViewModal from './YearViewModal'

export class ModalBookingList extends Component {
  constructor(props) {
    super(props)
    const { language, isFloorPlan } = props

    const bookingId = !isEmpty(props.bookings) ? props.bookings[0].id : ''

    this.state = {
      typeModal: props.typeModal,
      permission: {
        update: isFloorPlan ? checkPermission(props.permission, ROUTE.FLOORPLAN.ACTION.UPDATE) : checkPermission(props.permission, ROUTE.CALENDAR.ACTION.UPDATE),
        delete: isFloorPlan ? checkPermission(props.permission, ROUTE.FLOORPLAN.ACTION.DELETE) : checkPermission(props.permission, ROUTE.CALENDAR.ACTION.DELETE),
      },
      recurrence: null,
      repeatBookingText: REPEAT_BOOKING.OFF[language],
      selectedKeyRepeatOption: REPEAT_OPTION_STATUS.THIS_SCHEDULE,
      bookingId: bookingId,
      deletedReason: '',
      isOpenDeleteModalStepTwo: false,
      deletedDetail: {},
      selectedBooking: !isEmpty(props.bookings) ? props.bookings[0]: {},
      isClickCopy: false
    }

    this.modalRef = React.createRef()

    if (!isEmpty(props.bookings)) {
      this.state.recurrence = {
        ...props.bookings.recurrence
      }
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside = (event) => {
    const { isOpenDeleteModalStepTwo } = this.state

    if (this.modalRef.current && !this.modalRef.current.contains(event.target) && !isOpenDeleteModalStepTwo) {
      this.closeModal()
    }
  }

  closeModal = () => {
    this.props.closeModal()
  }
    
  handleClickCopy = (meetingLink) => {
    navigator.clipboard.writeText(meetingLink)
    this.setState({
      isClickCopy: true,
    }, () => {
      setTimeout(() => {
        this.closeToast()
      }, 3000)
    })
  }

  closeToast = () => {
    this.setState({
      isClickCopy: false,
    })
  }

  toEditBooking = (id) => {
    const { history, date } = this.props

    this.closeModal()
    let dateStr = ''
    if (date) {
      const parsedDate = typeof date === 'string' ? date.replace('Z', '') : date
      const d = new Date(parsedDate)
      const yyyy = d.getFullYear()
      const mm = String(d.getMonth() + 1).padStart(2, '0')
      const dd = String(d.getDate()).padStart(2, '0')
      dateStr = `?date=${yyyy}-${mm}-${dd}`
    }
    const returnTo = encodeURIComponent(history.location.pathname + history.location.search)
    const separator = dateStr ? '&' : '?'
    history.push(`/booking/${id}${dateStr}${separator}returnTo=${returnTo}`)
  }

  handleSelectBookingDetail = (id) => {
    const { history, date } = this.props
    
    this.closeModal()
    let dateStr = ''
    if (date) {
      const parsedDate = typeof date === 'string' ? date.replace('Z', '') : date
      const d = new Date(parsedDate)
      const yyyy = d.getFullYear()
      const mm = String(d.getMonth() + 1).padStart(2, '0')
      const dd = String(d.getDate()).padStart(2, '0')
      dateStr = `?date=${yyyy}-${mm}-${dd}`
    }
    history.push(`/meeting-info/${id}${dateStr}`)
  }

  closeDeleteModal = () => {
    this.setState({
      deleteStatus: false,
    })
  }

  deleteOrder = () => {
    this.props.deleteBooking()
  }

  onBookingView = (item) => {
    this.setState({
      typeModal: BOOKING_DETAIL_VIEW.BOOKING_VIEW,
    }, () => {
      this.props.setItemId(item.id) // from phase 1
      this.findSelectedBooking(item.id)
    })
  }

  reloadForYearAndDay = () => {
    if (this.props.isYearAndDay) {
      window.location.reload()
    }
  }

  deleteBookingConfirm = (deletedReason, isRecurrenceDelete) => {
    const { bookingcalendarAction, objGetParams } = this.props
    const { bookingId } = this.state

    const params = {
      bookingId,
      deletedReason,
      isRecurrenceDelete
    }

    bookingcalendarAction.deleteBookingById(params, () => {
      bookingcalendarAction.getListBooking(objGetParams(), () => {})
      this.reloadForYearAndDay()
    })
    
    this.closeModal()
  }

  onCloseModalStepTwo = () => {
    this.setState({ isOpenDeleteModalStepTwo: false })
  }

  onCloseModalStepOne = this.props.modalAction.closeModalConfirm

  onSubmitModalStepOne = (deletedReason) => {
    const { recurrence } = this.props.bookings[0]
    const { bookingId } = this.state

    const deletedProps = {
      bookingId,
      deletedReason,
    }

    this.setState({ 
      deletedDetail: deletedProps
    })

    this.setState({ deletedReason }, () => {
      if (recurrence) {
        this.setState({ isOpenDeleteModalStepTwo: true })
      } else {
        this.handleDelete({ ...deletedProps, deletedReason })
      }

      this.onCloseModalStepOne()
    })
  }

  handleDelete = (deletedDetail) => {
    const { deletedReason } = deletedDetail
    const { selectedKeyRepeatOption } = this.state

    const isRecurrenceDelete = selectedKeyRepeatOption === REPEAT_OPTION_STATUS.THIS_AND_FOLLOW_SCHEDULE

    this.deleteBookingConfirm(deletedReason, isRecurrenceDelete)
  }
  
  onSelectedRepeatOption = (key) => {
    this.setState({ selectedKeyRepeatOption: key })
  }

  findSelectedBooking = (id) => {
    const { bookings } = this.props

    this.setState({
      selectedBooking: bookings.find((item) => item.id === id),
      bookingId: id,
    })
  }

  render() {
    const {
      typeModal,
      isOpenDeleteModalStepTwo,
      selectedKeyRepeatOption,
      deletedDetail,
      selectedBooking,
      permission,
      isClickCopy
    } = this.state

    const {
      colorTheme,
      language,
      modalReducer,
      modalAction,
      nameModal,
      validate,
      position,
      bookings,
      date,
      companyTokenType
    } = this.props

    const cardStyles = {
      zIndex: 10,
      position: 'absolute',
      top: position.y,
      left: position.x,
    }

    return (
      <StyleModal
        ref={this.modalRef}
        colorTheme={colorTheme}
      >
         <div style={cardStyles}>
          {typeModal === BOOKING_DETAIL_VIEW.BOOKING_VIEW && (
            <BookingViewModal
              language={language}
              selectedBooking={selectedBooking}
              permission={permission}
              onUpdate={this.toEditBooking}
              onConfirm={selectedBooking.isEditable ? this.props.onClickConfirm : this.props.onClickInformation}
              handleSelectBookingDetail={this.handleSelectBookingDetail}
              onClose={this.closeModal}
              colorTheme={colorTheme}
              handleClickCopy={(meetingLink) => this.handleClickCopy(meetingLink)}
              closeToast={this.closeToast}
              isClickCopy={isClickCopy}
              companyTokenType={companyTokenType}
            />
          )}

          {typeModal === BOOKING_DETAIL_VIEW.MORE_VIEW && (
            <MoreViewModal
              language={language}
              date={date}
              bookings={bookings}
              onBookingView={this.onBookingView}
              onClose={this.closeModal}
              colorTheme={colorTheme}
            />
          )}

          {typeModal === BOOKING_DETAIL_VIEW.YEAR_VIEW && (
            <YearViewModal
              language={language}
              date={date}
              bookings={bookings}
              onBookingView={this.onBookingView}
              onClose={this.closeModal}
              colorTheme={colorTheme}
            />
          )}
        </div>

        <DeleteStepsModal
          isOpenStepOne={modalReducer.confirm}
          isOpenStepTwo={isOpenDeleteModalStepTwo}
          language={language}
          name={nameModal}
          validate={validate}
          selectedKey={selectedKeyRepeatOption}
          onCloseModalStepOne={this.onCloseModalStepOne}
          onCloseModalStepTwo={this.onCloseModalStepTwo}
          onSubmitModalStepOne={this.onSubmitModalStepOne}
          onSubmitModalStepTwo={() => this.handleDelete(deletedDetail)}
          onClickAction={this.deleteBookingConfirm}
          onSelected={this.onSelectedRepeatOption}
          colorTheme={colorTheme}
        />
      </StyleModal>
    )
  }
}

ModalBookingList.defaultProps = {
  isHideEditIcon: false,
  isHideDeleteIcon: false,
}

ModalBookingList.propTypes = {
  isHideEditIcon: PropTypes.bool,
  isHideDeleteIcon: PropTypes.bool,
}

export const mapDispatchToProps = ({ dispatch }) => {
  return {
    modalAction: bindActionCreators(MODAL.action, dispatch),
  }
}

export const mapStateToProps = ({ accountReducer, modalReducer }) => {
  return {
    accountReducer,
    modalReducer
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalBookingList)
